import React from "react";
import { Card } from "antd";

const pickNonEmpty = (person, ...keys) => {
  for (let i = 0; i < keys.length; i += 1) {
    const v = person[keys[i]];
    if (v != null && String(v).trim() !== "") {
      return String(v).trim();
    }
  }
  return "";
};

const formatOrderActor = (person) => {
  if (person == null || typeof person !== "object") {
    return "-";
  }
  const first = pickNonEmpty(
    person,
    "first_name",
    "firstName",
    "firstname"
  );
  const last = pickNonEmpty(
    person,
    "last_name",
    "lastName",
    "lastname",
    "surname"
  );
  const combined = [first, last].filter(Boolean).join(" ").trim();
  if (combined) {
    return combined;
  }
  const full = pickNonEmpty(person, "name", "full_name", "fullName");
  if (full) {
    return full;
  }
  if (person.username) {
    return String(person.username).trim();
  }
  if (person.email) {
    return String(person.email).trim();
  }
  return "-";
};

const formatOrderSource = (source) => {
  if (source == null || source === "") {
    return "-";
  }
  if (typeof source === "object") {
    const nested =
      source.name != null && String(source.name).trim() !== ""
        ? source.name
        : source.label != null && String(source.label).trim() !== ""
          ? source.label
          : source.display != null && String(source.display).trim() !== ""
            ? source.display
            : source.source;
    if (nested != null && String(nested).trim() !== "") {
      return String(nested).trim();
    }
    return "-";
  }
  const s = String(source).trim();
  return s || "-";
};

const MetaItem = ({ label, value }) => (
  <div className="order-meta-summary-card__item">
    <div className="order-meta-summary-card__label">{label}</div>
    <div className="order-meta-summary-card__value">{value}</div>
  </div>
);

const OrderMetaSummaryCard = ({ author, authorisedBy, source }) => (
  <Card
    className="order-meta-summary-card"
    size="small"
    bordered
  >
    <div className="order-meta-summary-card__grid">
      <MetaItem label="Source" value={formatOrderSource(source)} />
      <div className="order-meta-summary-card__divider" aria-hidden="true" />
      <MetaItem label="Order punched by" value={formatOrderActor(author)} />
      <div className="order-meta-summary-card__divider" aria-hidden="true" />
      <MetaItem
        label="Order authorised by"
        value={formatOrderActor(authorisedBy)}
      />
    </div>
  </Card>
);

export default OrderMetaSummaryCard;
